import React from 'react'
import styled from 'styled-components'

const PramonImg = styled.img`
  position: absolute;
  visibility: hidden;
`

export const Pramon = ({ pramon = null, layout }) => pramon
  ? <PramonImg src={`https://mer.stdout.cz/l.gif?s=pramon&v=1&e=view&t=${pramon[layout]}`} alt='pramon'/>
  : null
